/**
 * @generated SignedSource<<c7b918b244670f321bd9638c72fd1c71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatChannelMessageOptionsFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMessageActionsFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "ChatChannelMessageOptionsFragment";
};
export type ChatChannelMessageOptionsFragment$key = {
  readonly " $data"?: ChatChannelMessageOptionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMessageOptionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelMessageOptionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelMessageActionsFragment"
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};

(node as any).hash = "230c629f69cd693a384aeda4bad75690";

export default node;
